const COMPONENT_NAME = "CriteoAdSet";
const VIEW_NAME_SKELETON = "skeleton";
const SUPPORTED_IN_GRID_FORMATS = [
  "custom_costcoingriddisplay",
  "custom_costcocaingriddisplay",
  "DP"
];
export {
  COMPONENT_NAME,
  SUPPORTED_IN_GRID_FORMATS,
  VIEW_NAME_SKELETON
};
